module.exports = __webpack_public_path__ + "static/triangle-bglarge-a961a0c61dd31d0d8b087b70b1b5bfe8.png";